<template>
    <div class="editor-task-wrapper">
        <div v-if="loading" class="loading-overlay">
            <div class="modern-loader">
                <div class="loader-spinner">
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                    <div class="spinner-ring"></div>
                </div>
                <p class="loading-text">Yükleniyor...</p>
            </div>
        </div>
        <div v-else id="Editor-task">
            <div class="editor-task">
                <div class="editor-task-content">
                    <div class="status-switcher-wrapper" v-if="currentWorkflow">
                        <TaskStatusBar
                            :status-list="pipelineStages"
                            :current-status="currentStage.name"
                            @update-status="handleStageChange"
                        />
                    </div>
                    <div class="input title-input">
                        <div class="label">{{ $t("task.title") }}</div>
                        <a-input class="classic-new-input" v-model:value="form.title" :placeholder="$t('task.taskNumber')" />
                    </div>
                    <div class="editor-task-quill-editor">
                        <quill-editor
                            style="max-height: 20%; width: 100%"
                            v-model="form.description"
                            class="quill-editor"
                            :options="editorOption"
                            :placeholder="$t('task.createTaskDesc')"
                        />
                    </div>
                    <div class="editor-task-new-checklist">
                        <div class="checklist-data">
                        <div class="checklist-header" v-if="form.checklist.length > 0">
                            <span class="checklist-title">Checklist</span>
                            <a-progress
                            class="checklist-progress"
                            :stroke-color="{
                                '0%': '#ec4b1d',
                                '100%': '#ec4b1d',
                            }"
                            :percent="
                                (100 / form.checklist.length) *
                                form.checklist.filter((c) => c.isCompleted).length
                            "
                            :show-info="false"
                            />
                            <span class="checklist-status">
                            {{
                                $t("task.completedOfCheck", {
                                total: form.checklist.length,
                                completed: form.checklist.filter((c) => c.isCompleted).length,
                                })
                            }}
                            </span>
                        </div>
                        <div class="checklist-container mt-2" v-if="form.checklist.length > 0">
                            <div v-for="(checkbox, index) in form.checklist" :key="index" class="checklist-row">
                            <div class="checklist-column">
                                <a-checkbox class="kanban-checkbox large" v-model="checkbox.isCompleted" />
                            </div>
                            <div class="checklist-column">
                                <input
                                class="checklist-input"
                                v-model="checkbox.title"
                                />
                            </div>
                            <div class="checklist-column action">
                                <span class="material-icons delete-icon" @click="deleteCheckbox(index)">close</span>
                            </div>
                            </div>
                        </div>

                        <div class="checklist-button" @click="addNewCheckBox">
                            {{ !form.checklist.length ? $t("task.newCheckList") : $t("task.add") }}
                        </div>
                        </div>
                    </div>
                    <div class="editor-task-attach-files" @click="openFileInput">
                        <div class="attach-files">
                            <div class="text">
                                <div class="material-icons">attachment</div>
                                <div>{{ $t("task.attachFiles") }}</div>
                            </div>
                            <div class="logo">
                                <s3Logo />
                            </div>
                        </div>
                        <input id="fileInput" type="file" style="display: none" @change="uploadFile" />
                    </div>
                    <div class="row" style="display: grid; gap: 20px">
                        <div class="attach-files-visibility" v-for="attachment in form.attachments">
                            <template v-if="['png', 'jpeg', 'jpg'].includes(attachment.ext)">
                                <img
                                    :src="attachment.v2Format && attachment.cdnUrl
                                        ? attachment.cdnUrl
                                        : `https://static.supsis.live/${attachment.path + attachment._id}.${attachment.ext}`"
                                    :alt="attachment.name"
                                />
                            </template>
                            <template v-else>
                                <div class="file-icon">
                                    <span class="md-icon">insert_drive_file</span>
                                </div>
                            </template>
                            <div class="image-content">
                                <div class="text">
                                    <div v-if="editImageName === attachment._id" class="edit-img-name">
                                        <a-input type="text" v-model:value="attachment.name" />
                                    </div>
                                    <label v-else>{{ attachment.name }}</label>
                                </div>
                                <div class="description">
                                    {{ updatedAtFormated(attachment.updatedAt) }}
                                    <div class="edit-btn">
                                        <div class="underline" @click="deleteAttachment(attachment._id)">
                                            {{ $t("chatbotv2.delete") }}
                                        </div>
                                        |
                                        <div class="underline" @click="editImageNameFunc(attachment._id)">
                                            {{ $t("message.edit") }}
                                        </div>
                                        |
                                        <div
                                            class="underline"
                                            v-if="['png', 'jpeg', 'jpg'].includes(attachment.ext)"
                                            @click="openImage(attachment._id)"
                                        >
                                            {{ $t("task.view") }}
                                        </div>
                                        <div class="underline" v-else @click="openUrlInNewTab(attachment)">
                                            {{ $t("task.view") }}
                                        </div>
                                        |
                                        <div
                                            v-if="['png', 'jpeg', 'jpg'].includes(attachment.ext)"
                                            class="underline"
                                            @click="
                                                form.coverPhoto === attachment._id
                                                    ? removeCoverPhoto()
                                                    : setCoverPhoto(attachment._id)
                                            "
                                        >
                                            {{
                                                form.coverPhoto === attachment._id
                                                    ? $t("message.coverPhotoRemove")
                                                    : $t("message.coverPhotoSet")
                                            }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a-modal
                                id="task-attachment-image"
                                :visible="taskAttachmentsImgVisible"
                                @cancel="handleModalCancel"
                                :footer="false"
                            >
                                <img :src="selectedImage.url" :alt="selectedImage.name" />
                            </a-modal>
                        </div>
                    </div>
                    <div class="add-tags ml-2 mt-4">
                        <div
                            style="
                                margin-top: 10px;
                                color: #ec4b1d;
                                font-weight: bold;
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                            "
                        >
                            {{ $t("message.addTag") }}
                            <a-dropdown>
                                <a-button style="margin-left: 10px; padding: 2px">
                                    <span class="material-icons">add</span>
                                </a-button>
                                <a-menu slot="overlay">
                                    <a-menu-item v-for="tag in tags" :key="tag._id" @click="selectTag(tag)" style="display: flex; align-items: center;">
                                        <div
                                            class="showColor"
                                            :style="{
                                                backgroundColor: tag.color,
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '5px',
                                                marginRight: '8px'
                                            }">
                                        </div>
                                        <span>{{ tag.name }}</span>
                                    </a-menu-item>
                            </a-menu>
                            </a-dropdown>
                        </div>
                        <div v-if="form.tags.length > 0" class="selected-tags">
                            <div v-for="tag in form.tags" :key="tag._id" class="tag-item" :style="getTagStyle(tag.color)">
                                <span>{{ tag.name }}</span>
                                <span class="material-icons close-icon" @click="removeTag(tag._id)">close</span>
                            </div>
                        </div>
                    </div>
                    <div class="editor-task-new-subtask ml-4">
                        <div class="row gap-10">
                            <div
                                class="subtask-button"
                                @click="addNewSubtask(false)"
                            >
                                {{ $t("task.addSubtask") }}
                            </div>
                            <div
                            style="margin-top: 10px; display: flex; gap: 10px; flex-direction: column"
                            v-if="form.subTasks.length > 0"
                        >
                        <div class="subtask-container">
                            <div class="subtask-header">
                                <span>{{ $t("task.subtaskTitle") }}</span>
                                <span>{{ $t("task.assignee") }}</span>
                            </div>
                                <div v-for="(subtask, index) of form.subTasks" :key="index" class="subtask-row">
                                    <template v-if="!subtask.isExits">
                                        <div class="subtask-column">
                                        <a-checkbox class="kanban-checkbox large" v-model="subtask.completed" />
                                        <a-input class="classic-new-input" v-model:value="subtask.title" :placeholder="$t('task.subtaskTitle')" />
                                        </div>
                                        <div class="subtask-column">
                                        <a-select
                                            class="select-multiple"
                                            v-model:value="subtask.assignees"
                                            :options="visibilityUsers"
                                            :placeholder="$t('task.assignee')"
                                        ></a-select>
                                        </div>
                                    </template>

                                    <template v-else>
                                        <div class="subtask-column">
                                        <a-select
                                            class="select-multiple"
                                            v-model:value="subtask.taskId"
                                            :options="visibilityUsers"
                                            :placeholder="$t('task.assignee')"
                                        ></a-select>
                                        </div>
                                    </template>

                                    <div class="subtask-column action">
                                        <span class="material-icons delete-icon" @click="deleteSubtask(index)">close</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                            <!--                        <div-->
                            <!--                            style="margin-top: 10px; color: #ec4b1d; font-weight: bold; cursor: pointer"-->
                            <!--                            @click="addNewSubtask(true)"-->
                            <!--                        >-->
                            <!--                            {{ $t("task.addExistsSubtask") }}-->
                            <!--                        </div>-->
                        </div>
                    </div>
                    <div class="tab-menu-container">
                        <div class="tab-header">
                            <button
                                class="tab-button"
                                :class="{ active: activeTab === 'comments' }"
                                @click="activeTab = 'comments'"
                            >
                                {{ $t("task.comments") }}
                            </button>
                            <button
                                class="tab-button"
                                :class="{ active: activeTab === 'activities' }"
                                @click="activeTab = 'activities'"
                            >
                                Hareketler
                            </button>
                            <button
                                v-if="form.doneStatus && form.doneStatus.length > 0"
                                class="tab-button"
                                :class="{ active: activeTab === 'doneStatus' }"
                                @click="activeTab = 'doneStatus'"
                            >
                                Kapatılma Durumları
                            </button>
                        </div>

                        <div class="tab-content">
                            <div v-show="activeTab === 'comments'" class="comments-section">
                                <CreateComment :task-id="details.taskId" />
                                <listComment :task-id="details.taskId" />
                            </div>

                            <div v-show="activeTab === 'activities'" class="activities-section">
                                <ActivtyTask :task-id="details.taskId" />
                            </div>

                            <div v-show="activeTab === 'doneStatus'" class="done-status-section">
                                <div v-for="(status, index) in form.doneStatus" :key="index" class="done-status-card">
                                    <div class="done-status-header">
                                        <div class="status-info">
                                            <span class="material-icons" :class="getStatusIcon(status.status)">
                                                {{ getStatusIconName(status.status) }}
                                            </span>
                                            <span class="status-text">{{ status.status }}</span>
                                        </div>
                                        <div class="status-date">
                                            {{ formatDate(status.date) }}
                                        </div>
                                    </div>
                                    <div class="done-status-content">
                                        <div class="user-info">
                                            <Avatar
                                                :size="25"
                                                :key="1"
                                                :src="status.actor.gravatar"
                                                :username="status.actor.name"
                                                v-tippy="{
                                                    followCursor: true,
                                                    placement: 'bottom-end',
                                                }"
                                                :content="status.actor.email"
                                            />
                                            <span class="user-name">{{ status.actor.name }}</span>
                                        </div>
                                        <div class="status-description">
                                            {{ status.description }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="editor-info">
                <div class="info-task-list">
                    <div class="info-task-item">
                        <label>{{ $t("message.startDate") }}</label>
                        <div class="info-task-item-value">
                            <a-date-picker :suffixIcon="null" dropdownClassName="task-date-picker" v-model:value="form.startDate" show-time />
                        </div>
                    </div>
                    <div class="info-task-item">
                        <label>{{ $t("message.endDate") }}</label>
                        <div class="info-task-item-value">
                            <a-date-picker :suffixIcon="null" dropdownClassName="task-date-picker" v-model:value="form.endDate" show-time />
                        </div>
                    </div>
                    <div class="info-task-item">
                        <label>{{ $t("task.priority") }}</label>
                        <div class="info-task-item-value">
                            <a-select v-model:value="form.priority" style="width: 167px">
                                <a-select-option value="low">
                                    <div style="display: flex; gap: 5px">
                                        <LowIcon style="width: 20px; height: 20px; margin-top: 3px" />
                                        {{ $t("message.low") }}
                                    </div>
                                </a-select-option>
                                <a-select-option value="lowest">
                                    <div style="display: flex; gap: 5px">
                                        <LowestIcon style="width: 20px; height: 20px; margin-top: 2px" />
                                        {{ $t("message.lowest") }}
                                    </div>
                                </a-select-option>
                                <a-select-option value="medium">
                                    <div style="display: flex; gap: 5px">
                                        <MediumIcon style="width: 20px; height: 20px" />
                                        {{ $t("message.medium") }}
                                    </div>
                                </a-select-option>
                                <a-select-option value="high">
                                    <div style="display: flex; gap: 5px">
                                        <HighIcon style="width: 20px; height: 20px; margin-top: 3px" />
                                        {{ $t("message.high") }}
                                    </div>
                                </a-select-option>
                                <a-select-option value="highest">
                                    <div style="display: flex; gap: 5px">
                                        <HighestIcon style="width: 20px; height: 20px; margin-top: 2px" />
                                        {{ $t("message.highest") }}
                                    </div>
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>
                    <div class="info-task-item">
                        <label>{{ $t("task.owner") }}</label>
                        <div class="info-task-item-value">
                            <a-select
                                style="width: 167px"
                                class="select-multiple"
                                v-model:value="form.owner"
                                :options="visibilityUsers"
                                :placeholder="$t('task.owner')"
                                showSearch
                                :filter-option="filterOption"
                            />
                        </div>
                    </div>
                    <div class="info-task-item">
                        <label>{{ $t("task.assignee") }}</label>
                        <div class="info-task-item-value">
                            <a-select
                                style="width: 167px"
                                v-model:value="form.assignees"
                                mode="multiple"
                                :placeholder="$t('task.selectAssginee')"
                                :max-tag-count="maxTagCount"
                                :options="visibilityUsers"
                                :filter-option="filterOption"
                            />
                        </div>
                    </div>
                    <div class="info-task-item">
                        <label>Takipçi</label>
                        <div class="info-task-item-value">
                            <a-select
                                style="width: 167px"
                                v-model:value="form.followers"
                                mode="multiple"
                                :placeholder="'Görevin Takipcileri'"
                                :max-tag-count="maxTagCount"
                                :options="visibilityUsers"
                                :filter-option="filterOption"
                            />
                        </div>
                    </div>
                    <!--                şuan için completed tarihi mevcut değil data içinde-->
                    <!--                <div class="info-task-item">-->
                    <!--                    <label>Completed Date</label>-->
                    <!--                    <div class="info-task-item-value">01.05.2024 5:41 am</div>-->
                    <!--                </div>-->
                    <div class="info-task-item">
                        <label>Task ID</label>
                        <div class="info-task-item-value">{{ form._id }}</div>
                    </div>
                    <!--                <div class="info-task-item">-->
                    <!--                    <label>{{ $t("chatbotv2.lastUpdate") }}</label>-->
                    <!--                    <div class="info-task-item-value">3 days ago</div>-->
                    <!--                </div>-->
                    <div class="info-task-item" style="display: block" v-if="usersMap[form.createdBy.user]">
                        <label> {{ $t("message.taskCreator") }} </label>
                        <div class="create-task-avatar-message">
                            <Avatar
                                :size="25"
                                :key="1"
                                :src="usersMap[form.createdBy.user] && usersMap[form.createdBy.user].gravatar"
                                :username="usersMap[form.createdBy.user] && usersMap[form.createdBy.user].name"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="usersMap[form.createdBy.user] && usersMap[form.createdBy.user].email"
                            />
                            <label>
                                {{ (usersMap[form.createdBy.user] && usersMap[form.createdBy.user].name) || 'Unknown User' }} Kullanıcısı bu görevi
                                {{ formattedCreatedAt }} tarihinde oluşturdu
                            </label>
                        </div>
                    </div>
                    <div class="info-task-item" style="display: block" v-if="form.createdBy.type === 'api'">
                        <label> {{ $t("message.taskCreator") }} </label>
                        <div class="create-task-avatar-message">
                            <Avatar
                                :size="25"
                                :key="1"
                                src="https://static.supsis.live/common/email/supsisyazisislogo.png"
                                username="Chatbot"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="null"
                            />
                            <label>API tarafından bu görev, {{ formattedCreatedAt }} tarihinde oluşturdu</label>
                        </div>
                    </div>
                    <div class="info-task-item" style="display: block" v-if="form.createdBy.type === 'chatbot'">
                        <label> {{ $t("message.taskCreator") }} </label>
                        <div class="create-task-avatar-message">
                            <Avatar
                                :size="25"
                                :key="1"
                                src="https://static.supsis.live/common/email/supsisyazisislogo.png"
                                username="Chatbot"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="null"
                            />
                            <label>Chatbot tarafından bu görev, {{ formattedCreatedAt }} tarihinde oluşturdu</label>
                        </div>
                    </div>
                    <div class="info-task-item" style="display: block" v-if="form.createdBy.type === 'automation'">
                        <label> {{ $t("message.taskCreator") }} </label>
                        <div class="create-task-avatar-message">
                            <Avatar
                                :size="25"
                                :key="1"
                                src="https://static.supsis.live/common/email/supsisyazisislogo.png"
                                username="Chatbot"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="null"
                            />
                            <label>Otomasyon tarafından bu görev, {{ formattedCreatedAt }} tarihinde oluşturdu</label>
                        </div>
                    </div>
                    <div v-if="tableRecords.length > 0" class="info-task-item" style="display: block">
                        <label>İlgili Tablo Kayıtları</label>
                        <div
                            v-for="(record, index) in tableRecords"
                            :key="record._id"
                            class="info-task-item"
                            @click="viewRecord(record)"
                            style="margin-left: 10px; margin-bottom: 5px;"
                        >
                            <div style="display: flex; align-items: center; cursor:pointer">
                                <span class="material-icons" style="margin-right: 8px;">table_view</span>
                                Tablo Kaydı {{ index + 1 }}
                            </div>
                        </div>
                    </div>
                    <div class="info-task-item" style="display: block">
                        <label>İlgili Ziyaretçi</label>
                        <div v-if="visitorRelation" class="task-avatar-message">
                            <div class="visitor-info" @click="visitorDetail">
                                <Avatar
                                    :size="25"
                                    :src="visitorRelation.visitor.gravatar"
                                    :username="visitorRelation.visitor.fullname"
                                    v-tippy="{
                                        followCursor: true,
                                        placement: 'bottom-end',
                                    }"
                                    :content="visitorRelation.visitor.fullname"
                                />
                                <label>{{ visitorRelation.visitor.fullname }}</label>
                            </div>
                            <div class="delete-icon" @click="removeVisitor">
                                <span class="material-icons">close</span>
                            </div>
                        </div>
                        <div v-else class="add-visitor" @click="addVisitor">
                            <span class="material-icons">add</span>
                            <span>Ziyaretçi Ekle</span>
                        </div>
                        <Modal2
                            v-if="showModal"
                            @cancel="closeModal"
                            :title="'Kişi Seç'"
                            :okText="'Kaydet'"
                            xlarge
                            className="contact-picker-modal keydown-prevent-modal"
                        >
                            <List picker-mode @select="handleVisitorSelect" />
                        </Modal2>
                    </div>
                    <div class="info-task-item" style="display: block" v-if="getUserIds(form).length > 0">
                        <label>{{ $t("task.assignees") }}</label>
                        <div class="task-avatar-message" v-for="userId of getUserIds(form)" :key="userId">
                            <Avatar
                                :size="25"
                                :key="1"
                                :src="usersMap[userId] && usersMap[userId].gravatar"
                                :username="usersMap[userId] && usersMap[userId].name"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="usersMap[userId] && usersMap[userId].email"
                            />
                            <label>{{ (usersMap[userId] && usersMap[userId].name) || 'Unknown User' }}</label>
                            <div
                                class="msg-icon"
                                v-if="userId._id !== loggedUser._id"
                                @click="startDM(usersMap[userId]._id)"
                            >
                                <span class="md-icon">contact_mail</span>
                            </div>
                        </div>
                    </div>
                    <div class="info-task-item" style="display: block" v-if="getUserIdsOwner(form).length > 0">
                        <label>{{ $t("task.owner") }}</label>
                        <div class="task-avatar-message" v-for="userId of getUserIdsOwner(form)" :key="userId">
                            <Avatar
                                :size="25"
                                :key="1"
                                :src="usersMap[userId] && usersMap[userId].gravatar"
                                :username="usersMap[userId] && usersMap[userId].name"
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                }"
                                :content="usersMap[userId] && usersMap[userId].email"
                            />
                            <label>{{ (usersMap[userId] && usersMap[userId].name) || 'Unknown User' }}</label>
                            <div
                                class="msg-icon"
                                v-if="userId._id !== loggedUser._id"
                                @click="startDM(usersMap[userId]._id)"
                            >
                                <span class="md-icon">contact_mail</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import s3Logo from "../svg/S3.vue";
import Avatar from "vue-avatar";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import SYSTEM_PUBSUB from "../../../utils/systemPubSub";
import { uploadAsset } from "../../../api/assetUpload";
import axios from "axios";
import moment from "moment/moment";
import LowIcon from "../../svg/task/LowIcon.vue";
import LowestIcon from "../../svg/task/LowestIcon.vue";
import MediumIcon from "../../svg/task/MediumIcon.vue";
import HighIcon from "../../svg/task/HighIcon.vue";
import HighestIcon from "../../svg/task/HighestIcon.vue";
import CreateComment from "../../comment/CreateComment.vue";
import listComment from "../../comment/ListComment.vue";
import TaskStatusBar from "../../../views/Pages/Tasks/components/TaskStatusBar.vue";
import Modal2 from "../../common/Modal2.vue";
import List from "../../../views/Pages/Visitors/List.vue";
import ActivtyTask from "./ActivtyTask.vue";

export default {
    name: "EditorTask",
    components: {
        s3Logo,
        Avatar,
        LowIcon,
        LowestIcon,
        MediumIcon,
        HighIcon,
        HighestIcon,
        CreateComment,
        listComment,
        TaskStatusBar,
        Modal2,
        List,
        ActivtyTask
    },
    props: {
        details: {
            type: Object,
        },
    },
    data() {
        return {
            loading: true,
            showModal: false,
            maxTagCount: 1,
            form: {
                title: null,
                description: null,
                priority: "low",
                checklist: [],
                assigneeIds: [],
                ownerId: null,
                collaboratorIds: [],
                followerIds: [],
                subTasks: [],
                startDate: null,
                endDate: null,
                workflowId: null,
                pipelineStageId: null,
                color: null,
                createdAt: null,
                attachments: [],
                createdBy: {
                    type: null,
                    user: null,
                },
                tags: [],
                coverPhoto: null,
            },
            editorOption: {
                theme: "snow",
                modules: {
                    toolbar: [
                        ["bold", "italic", "underline", "strike"],
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],
                        [{ color: [] }, { background: [] }],
                        [{ align: [] }],
                        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                        ["link"],
                    ],
                },
            },
            editImageName: null,
            isSaved: false,
            taskAttachmentsImgVisible: false,
            selectedImage: {
                url: "",
                name: "",
            },
            tags: [],
            activeTab: 'comments',
        };
    },
    computed: {
        ...mapState({
            loggedUser: (state) => state.auth.user || state.auth.adminUser,
            usersMap: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc.push({
                        value: user._id,
                        label: user.name,
                    });
                    return acc;
                }, []),
            defaultWorkflow: (state) => state.tasks.defaultWorkflow,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            workflows: (state) =>
                state.tasks.workflows.reduce((acc, workflow) => {
                    acc[workflow._id] = workflow;
                    return acc;
                }, {}),
        }),
        visitorRelation() {
            return this.form?.relations?.find((relation) => relation.type === "visitor");
        },
        tableRecords() {
            return this.form?.relations?.filter((relation) => relation.type === "tableRecord") || [];
        },
        formattedCreatedAt() {
            return moment(this.form.createdAt).format("DD/MM/YYYY HH:mm");
        },
        visibilityUsers() {
            const workflow = this.workflows[this.form.workflow];
            if (workflow && workflow.visibility && workflow.visibility.users && workflow.visibility.users.length > 0) {
                return this.users.filter((user) => workflow.visibility.users.includes(user.value));
            } else {
                return this.users;
            }
        },
        currentWorkflow() {
            return this.workflows[this.form.workflow];
        },
        currentStage() {
            return this.currentWorkflow?.pipeline.find((p) => p._id === this.form.pipelineStage) || {};
        },
        pipelineStages() {
            if (!this.currentWorkflow) return [];

            return this.currentWorkflow.pipeline.map((stage) => ({
                title: stage.name,
                label: stage.name,
                type: stage.type,
                _id: stage._id,
            }));
        },
    },
    methods: {
        ...mapActions({
            getTags: "tag/getTags",
            getTaskDetail: "tasks/getTaskDetail",
            attachmentsDelete: "tasks/attachmentsDelete",
            addNewWindow: "app/addNewWindow",
        }),
        visitorDetail() {
            this.addNewWindow({
                type: "show-visitor",
                title: `${this.visitorRelation.visitor.fullname || "Visitor"} Profile`,
                payload: {
                    visitorId: this.visitorRelation.visitor._id,
                },
                footer: false,
            });
        },
        async getTaskTags() {
            try {
                this.tags = await this.getTags("task");
            } catch (error) {
                console.error("Error fetching tags:", error);
            }
        },
        setCoverPhoto(attachmentId) {
            this.form.coverPhoto = attachmentId;
            this.$toasted.success("Kapak fotoğrafı başarıyla ayarlandı", {
                duration: 3000,
            });
        },
        removeCoverPhoto() {
            this.form.coverPhoto = null;
            this.$toasted.success("Kapak fotoğrafı kaldırıldı", {
                duration: 3000,
            });
        },
        getTagStyle(color) {
            const isLight = this.isLightColor(color);
            return {
                backgroundColor: color,
                color: isLight ? "#000" : "#fff",
            };
        },
        isLightColor(color) {
            const r = parseInt(color.slice(1, 3), 16);
            const g = parseInt(color.slice(3, 5), 16);
            const b = parseInt(color.slice(5, 7), 16);
            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            return brightness > 155;
        },
        getSelectedTagIds() {
            return this.form.tags.map((tag) => tag._id);
        },
        selectTag(tag) {
            const isExists = this.form.tags.find((selectedTag) => selectedTag._id === tag._id);
            if (isExists) {
                this.form.tags = this.form.tags.filter((selectedTag) => selectedTag._id !== tag._id);
            } else {
                this.form.tags = _.uniq([...this.form.tags, tag]);
            }
        },
        removeTag(tagId) {
            this.form.tags = this.form.tags.filter((tag) => tag._id !== tagId);
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        addNewCheckBox() {
            if (
                this.form.checklist[this.form.checklist.length - 1] &&
                !this.form.checklist[this.form.checklist.length - 1].title
            ) {
                this.form.checklist = this.form.checklist.slice(0, this.form.checklist.length - 1);
            } else {
                this.form.checklist = [
                    ...this.form.checklist,
                    {
                        isCompleted: false,
                        title: null,
                    },
                ];
            }
        },
        deleteCheckbox(index) {
            this.form.checklist = this.form.checklist.filter((c, i) => i !== index);
        },
        addNewSubtask(isExits) {
            if (
                this.form.subTasks[this.form.subTasks.length - 1] &&
                (this.form.subTasks[this.form.subTasks.length - 1].isExits
                    ? !this.form.subTasks[this.form.subTasks.length - 1].taskId
                    : !this.form.subTasks[this.form.subTasks.length - 1].title)
            ) {
                this.form.subTasks = this.form.subTasks.slice(0, this.form.subTasks.length - 1);
            } else {
                this.form.subTasks = [
                    ...this.form.subTasks,
                    isExits
                        ? {
                              isExits,
                              taskId: null,
                          }
                        : {
                              completed: false,
                              assignees: this.users[0]?.value,
                              title: null,
                          },
                ];
            }
        },
        deleteSubtask(index) {
            this.form.subTasks = this.form.subTasks.filter((c, i) => i !== index);
        },
        updatedAtFormated(a) {
            const date = this.$moment(a).format("DD.MM.YYYY HH:mm");
            return date;
        },
        getUserIds(form) {
            return _.uniq([form.assignees].flat()).filter((c) => c);
        },
        getUserIdsOwner(form) {
            return _.uniq([form.owner].flat()).filter((c) => c);
        },
        getCreatedBy(form) {
            if (form.createdBy.type === "api") {
                return "API";
            } else {
                return this.usersMap[form.createdBy.user];
            }
        },
        startDM(id) {
            this.$router.push("/chat?tabIndex=teamChat");
            this.$emit("close-modal");
            setTimeout(() => {
                SYSTEM_PUBSUB.publish(SYSTEM_PUBSUB.MESSAGE_TYPES.START_AGENT_CHAT, { userId: id });
            }, 500);
        },
        openFileInput() {
            document.getElementById("fileInput").click();
        },
        beforeUpload(file) {
            // const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png";
            // if (!isJpgOrPng) {
            //     this.$toasted.show("Sadece Resim Yükleyebilirsiniz!", {
            //         duration: 3000,
            //     });
            // }
            const isLt5M = file.size / 1024 / 1024 < 50;
            if (!isLt5M) {
                this.$toasted.show("Resminizin Boyutu En Fazla 5MB Olmalıdır!", {
                    duration: 3000,
                });
            }
            // return isJpgOrPng && isLt5M;
            return isLt5M;
        },
        async uploadFile(e) {
            let {
                files: [file],
            } = document.getElementById(e.target.id);
            if (!this.beforeUpload(file)) return;
            let path = `${this.site._id}/tasks-attachments/`;
            try {
                let imdUploadData = await uploadAsset({
                    path,
                    name: file.name,
                    size: file.size,
                    type: "task-attachment",
                    mime: file.type,
                    ext: file.name.split(".").pop(),
                });
                await axios({
                    method: imdUploadData.data.method,
                    url: imdUploadData.data.url,
                    data: file,
                    headers: { "Content-Type": "application/octet-stream" },
                });
                this.$toasted.success(this.$t("message.successImgUpload"), {
                    duration: 1000,
                    position: "bottom-center",
                });
                this.form.attachments = [...this.form.attachments, imdUploadData.data.asset];
            } catch (e) {
                this.$toasted.error(this.$t("message.errorImgUpload"), {
                    duration: 1000,
                    position: "bottom-center",
                });
            }
        },
        async deleteAttachment(id) {
            this.form.attachments = this.form.attachments.filter((c) => c.id !== id);
            if (this.details?.taskId) {
                this.attachmentsDelete({ taskId: this.details?.taskId, attachmentId: id });
            } else {
                this.attachmentsDelete({ attachmentId: id });
            }
        },
        editImageNameFunc(id) {
            this.editImageName = this.editImageName !== id && id;
        },
        openImage(id) {
            const image = this.form.attachments.find((attachment) => attachment._id === id);

            if (image) {
                this.selectedImage = {
                    url: image.v2Format && image.cdnUrl
                        ? image.cdnUrl
                        : `https://static.supsis.live/${image.path + image._id}.${image.ext}`,
                    name: image.name,
                };
                this.taskAttachmentsImgVisible = true;
            }
        },
        handleModalCancel(event) {
            event.stopPropagation();
            this.taskAttachmentsImgVisible = false;
        },
        openUrlInNewTab(attachment) {
            const url = attachment.v2Format && attachment.cdnUrl
                ? attachment.cdnUrl
                : `https://static.supsis.live/${attachment.path + attachment._id}.${attachment.ext}`;
            window.open(url, "_blank");
        },
        async handleStageChange(stageName) {
            const stage = this.currentWorkflow.pipeline.find((p) => p.name === stageName);
            if (stage && stage._id !== this.form.pipelineStage) {
                this.form.pipelineStage = stage._id;
            }
        },
        addVisitor() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        handleVisitorSelect(visitor) {
            console.log("visitorrrrrr", visitor);
            if (!this.form.relations) {
                this.form.relations = [];
            }

            const visitorRelation = {
                type: "visitor",
                visitor: {
                    _id: visitor._id,
                    fullname: visitor.fullname,
                    gravatar: visitor.gravatar || visitor.avatar,
                },
            };

            const existingIndex = this.form.relations.findIndex((rel) => rel.type === "visitor");
            if (existingIndex !== -1) {
                this.form.relations[existingIndex] = visitorRelation;
            } else {
                this.form.relations.push(visitorRelation);
            }

            this.closeModal();
            this.$message.success("Ziyaretçi başarıyla eklendi");
        },
        removeVisitor() {
            if (this.form.relations) {
                this.form.relations = this.form.relations.filter((rel) => rel.type !== "visitor");
                this.$message.success("Ziyaretçi başarıyla silindi");
            }
        },
        viewRecord(relation) {
            if (relation && relation.tableRecord) {
                this.addNewWindow({
                    id: relation.tableRecord,
                    type: "table-record-viewer",
                    title: this.form.title,
                    payload: {
                        tableId: relation.tableRecord.table,
                        recordId: relation.tableRecord._id,
                    },
                    multiple: true,
                    autoClose: false,
                });
            } else {
                console.error("No tableRecord relation found");
            }
        },
        getStatusIcon(status) {
            switch (status) {
                case 'Won':
                    return 'status-won';
                case 'Lost':
                    return 'status-lost';
                case 'Paused':
                    return 'status-paused';
                default:
                    return '';
            }
        },
        getStatusIconName(status) {
            switch (status) {
                case 'Won':
                    return 'check_circle';
                case 'Lost':
                    return 'cancel';
                case 'Paused':
                    return 'pause_circle';
                default:
                    return 'help';
            }
        },
        formatDate(date) {
            return this.$moment(date).format('DD/MM/YYYY HH:mm');
        },
    },
    mounted() {
        this.getTaskTags();
        this.getTaskDetail(this.details.taskId)
            .then((data) => {
                this.form = data;
            })
            .catch(error => {
                console.error('Task load error:', error);
                this.$message.error(this.$t('errors.taskLoadFailed'));
            })
            .finally(() => {
                this.loading = false;
            });
    },
    watch: {
        form: {
            handler() {
                this.$emit("update-form", {
                    ...this.form,
                    attachments: this.form.attachments,
                    tags: this.getSelectedTagIds(),
                });
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
.task-date-picker {
    z-index: 999999;
}
#Editor-task {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    margin-top: -20px;

    .subtask-container {
        display: flex;
        flex-direction: column;
        gap: 10px;
        width: 100%;
    }

    .subtask-header {
        display: grid;
        grid-template-columns: 1fr 1fr 80px;
        background: #f9f9f9;
        padding: 10px;
        font-weight: bold;
        border-radius: 5px;
        text-align: center;
    }

    .subtask-row {
        display: grid;
        grid-template-columns: 1fr 1fr 80px;
        align-items: center;
        padding: 10px;
        border-bottom: 1px solid #eee;
    }

    .subtask-column {
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: center;
    }

    .action {
        display: flex;
        justify-content: center;
    }

    .delete-icon {
        cursor: pointer;
        color: red;
        transition: transform 0.2s ease;
    }

    .delete-icon:hover {
        transform: scale(1.2);
    }

    .checklist-button {
        border: 1px solid #f1f1f1;
        padding: 15px;
        border-radius: 10px;
        margin-top: 10px;
        color: rgb(236, 75, 29);
        font-weight: bold;
        cursor: pointer;
        width: 32vh;
        text-align: center;
        background-color: #fff;
        transition: all 0.3s ease-in-out;
    }

    .checklist-button:hover {
        background-color: rgba(236, 75, 29, 0.1);
        border-color: rgba(236, 75, 29, 0.6);
        color: rgb(200, 50, 20);
        transform: scale(1.02);
    }

    .subtask-button {
        border: 1px solid #f1f1f1;
        padding: 15px;
        border-radius: 10px;
        margin-top: 10px;
        color: rgb(236, 75, 29);
        font-weight: bold;
        cursor: pointer;
        width: 32vh;
        text-align: center;
        background-color: #fff;
        transition: all 0.3s ease-in-out;
    }

    .subtask-button:hover {
        background-color: rgba(236, 75, 29, 0.1);
        border-color: rgba(236, 75, 29, 0.6);
        color: rgb(200, 50, 20);
        transform: scale(1.02);
    }
    .editor-task-new-checklist {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .checklist-header {
        display: flex;
        align-items: center;
        gap: 15px;
        font-size: 16px;
        font-weight: bold;
    }

    .checklist-progress {
        width: 200px;
    }

    .checklist-status {
        width: 200px;
        font-size: 14px;
        color: #666;
    }

    .checklist-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    .checklist-row {
        display: grid;
        grid-template-columns: 50px 1fr 60px;
        align-items: center;
        padding: 10px;
        border-bottom: 1px solid #eee;
    }

    .checklist-header-row {
        font-weight: bold;
        background: #f9f9f9;
        border-radius: 5px;
        padding: 10px;
        display: grid;
        grid-template-columns: 50px 1fr 60px;
        text-align: center;
    }

    .checklist-header-row span {
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .checklist-column {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .checklist-input {
        width: 100%;
        border: none;
        outline: none;
        background: #f1f1f1;
        border-radius: 4px;
        padding: 5px 10px;
    }

    .editor-task {
        width: 70%;
        height: 100%;
        background-color: #fff;
        border-right: 2px solid #dddddd;

        .editor-task-header {
            width: 95%;
            height: auto;
            background-color: #fff;
            border-bottom: 1px solid #dddddd;
            display: flex;
            align-items: center;
            padding: 0 20px;
            font-size: 16px;
            font-weight: 500;
            color: #333333;

            .editor-task-todo-select {
                width: 200px !important;
                height: 70px !important;
                margin-bottom: -20px !important;
                margin-top: 20px !important;
            }

            .editor-re-open-btn {
                width: 110px !important;
                margin-left: 15px;
            }
        }

        .editor-task-content {
            width: 100%;
            height: calc(100% - 50px);
            background-color: #fff;
            padding: 20px;

            .editor-task-quill-editor {
                width: 100%;
                height: 100%;
                background-color: #fff;
                border: 1px solid #dddddd;
                border-radius: 5px;

                .quill-editor {
                    .ql-toolbar.ql-snow {
                        background: #f1f1f1 !important;
                        border-radius: 4px 4px 0px 0px;
                        border: none;
                    }

                    .ql-container.ql-snow {
                        height: 200px;
                        max-height: 200px;
                        min-height: 200px;
                        background: #f1f1f1;
                        border-radius: 0px 0px 4px 4px;
                        overflow: hidden;
                        border: none !important;
                    }
                }
            }

            .editor-task-new-checklist {
                width: 100%;
                height: 100%;
                background-color: #fff;
                border-radius: 5px;
                margin-top: 20px;

                .checklist-data {
                    width: 100%;

                    .ant-progress-success-bg,
                    .ant-progress-bg {
                        background-color: #ec4b1d !important;
                    }

                    .kanban-checkbox {
                        .ant-checkbox-inner {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 20px;
                            height: 20px;

                            &::after {
                                border: 2px solid #fff;
                                left: 20%;
                                width: 7px;
                                height: 11px;
                                border-top: 0;
                                border-left: 0;
                            }
                        }

                        .ant-checkbox.ant-checkbox-checked {
                            .ant-checkbox-inner {
                                border: 3px solid #ec4b1d !important;
                                background-color: #ec4b1d !important;
                            }
                        }

                        .ant-checkbox-checked::after {
                            border: 1px solid #ec4b1d !important;
                        }

                        .ant-checkbox-wrapper:hover .ant-checkbox-inner,
                        .ant-checkbox:hover .ant-checkbox-inner,
                        .ant-checkbox-input:focus + .ant-checkbox-inner {
                            border: 1px solid #ec4b1d !important;
                        }
                    }
                }
            }

            .editor-task-attach-files {
                cursor: pointer;
                width: 100%;
                height: 100%;
                background-color: #fff;
                margin-top: 20px;
                padding-bottom: 20px;
                border-bottom: 1px solid #dddddd;

                .attach-files {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 240px;
                    border: 1px solid #f1f1f1;
                    padding: 3px 20px;
                    border-radius: 10px;
                    margin-top: 15px;
                    font-weight: bold;

                    .text {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }

                    .logo svg {
                        width: 40px;
                    }
                }
            }

            .editor-task-new-subtask {
                width: 100%;
                height: 100%;
                background-color: #fff;
                margin-top: 10px;
                padding-bottom: 20px;
            }

            .input {
                font-weight: bold;

                .label {
                    font-size: 16px;
                    margin-bottom: 4px;
                }

                &.title-input {
                    width: 100%;
                    margin-bottom: 20px;
                }

                &.priority-input {
                    width: 20%;
                }
            }
        }
    }

    .editor-info {
        width: 30%;
        height: 100vh;
        background-color: #fff;

        .info-task-list {
            display: flex;
            flex-direction: column;
            height: 100vh;
            padding: 20px;

            .add-calendar {
                background-color: #f1f1f1;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: 16px;
                color: #333333;
                cursor: pointer;
                margin-bottom: 10px;
                padding: 3px;
                border-radius: 10px;
            }

            .info-task-item {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                padding: 10px 0;
                border-bottom: 1px solid #dddddd;

                label {
                    font-size: 14px;
                    font-weight: 500;
                    color: #333333;
                }

                .info-task-item-value {
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                }

                .task-avatar-message {
                    display: flex;
                    align-items: center;
                    gap: 7px;
                    margin: 3px;
                }

                .task-avatar-message label {
                    width: 100px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                }

                .task-avatar-message .msg-icon {
                    color: #f76036;
                    cursor: pointer;
                    margin-left: auto;
                }

                .task-avatar-message:hover {
                    background-color: #f0f0f0;
                }

                .create-task-avatar-message {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                    padding: 10px;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                    margin-bottom: 10px;
                    background-color: #f9f9f9;
                }

                .create-task-avatar-message label {
                    flex-grow: 1;
                    margin-left: 10px;
                    font-size: 14px;
                    color: #333;
                    text-align: center;
                }

                .create-task-avatar-message Avatar {
                    border-radius: 50%;
                    border: 2px solid #ddd;
                }
            }
        }
    }

    .classic-new-input {
        padding: 20px;
        background: #f1f1f1;
        border: none;
        color: #3c3c3c;
        font-weight: bold;
        font-size: 14px;

        &:focus {
            border: #ec4a1d65 !important;
            box-shadow: 0 0 0 2px #ffaa0037;
        }

        &::placeholder {
            opacity: 1;
            font-weight: bold;
        }
    }

    .attach-files-visibility {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-top: 15px;

        .image-content {
            display: inline-grid;
            align-items: center;
            gap: 5px;

            .text {
                display: flex;
                align-items: center;
                gap: 10px;

                label {
                    font-size: 12px;
                    font-weight: bold;
                    color: #333333;
                }
            }

            .description {
                cursor: pointer;
                font-size: 12px;
                color: #333333;

                .edit-btn {
                    display: flex;
                    align-items: center;
                    gap: 5px;
                    color: #ec4b1d;
                    font-weight: bold;
                    font-size: 12px;
                    cursor: pointer;

                    .underline {
                        text-decoration: underline;
                    }
                }
            }
        }

        img {
            object-fit: cover;
            width: 100px;
            height: auto;
        }

        .text {
            display: flex;
            align-items: center;
            gap: 5px;
        }

        label {
            margin-bottom: 0px;
        }
    }

    .ant-select-selection {
        height: 30px !important;
        overflow: hidden;
    }

    .selected-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 10px;
    }

    .tag-item {
        display: flex;
        align-items: center;
        padding: 5px 10px;
        border-radius: 20px;
        color: #fff;
        font-weight: bold;
    }

    .close-icon {
        margin-left: 10px;
        cursor: pointer;
    }
}

#task-attachment-image {
    .ant-modal {
        z-index: 99999 !important;
        width: 52vw !important;
    }

    .ant-modal-wrap {
        z-index: 99999 !important;
    }

    .ant-modal-close {
        .ant-modal-close-x {
            color: white;
            position: absolute;
        }
    }

    .ant-modal-content {
        border-radius: 4px;
    }

    .ant-modal-body {
        padding: 0 !important;
    }

    img {
        width: 100%;
        height: 100%;
    }

    .ant-modal-mask {
        z-index: 99999 !important;
        background-color: rgba(0, 0, 0, 0.75);
    }
}

.status-switcher-wrapper {
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 4px 0;

    &::-webkit-scrollbar {
        height: 4px;
    }

    &::-webkit-scrollbar-track {
        background: #f5f5f5;
        border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb {
        background: #ccc;
        border-radius: 2px;

        &:hover {
            background: #999;
        }
    }
}

.add-visitor {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: #ec4b1d;
    padding: 8px;
    border-radius: 4px;
    transition: background-color 0.3s;

    &:hover {
        background-color: #f5f5f5;
    }

    .material-icons {
        font-size: 20px;
    }

    span {
        font-weight: 500;
    }
}

.task-avatar-message {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px;
    border-radius: 4px;
    transition: background-color 0.3s;

    &:hover {
        background-color: #f5f5f5;
    }

    .visitor-info {
        display: flex;
        align-items: center;
        gap: 7px;
        cursor: pointer;
    }

    .delete-icon {
        cursor: pointer;
        color: #999;
        transition: color 0.3s;

        &:hover {
            color: #ec4b1d;
        }

        .material-icons {
            font-size: 18px;
        }
    }
}

.editor-task-wrapper {
    position: relative;
    min-height: 500px;
    
    .loading-overlay {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(8px);
        z-index: 1000;

        .modern-loader {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;

            .loader-spinner {
                position: relative;
                width: 80px;
                height: 80px;

                .spinner-ring {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    border: 3px solid transparent;
                    border-top-color: #ec4b1d;
                    animation: spin 1.5s cubic-bezier(0.68, -0.55, 0.265, 1.55) infinite;

                    &:nth-child(1) {
                        animation-delay: 0s;
                        border-top-color: #ec4b1d;
                    }

                    &:nth-child(2) {
                        width: 90%;
                        height: 90%;
                        top: 5%;
                        left: 5%;
                        animation-delay: -0.5s;
                        border-top-color: #ff7849;
                    }

                    &:nth-child(3) {
                        width: 80%;
                        height: 80%;
                        top: 10%;
                        left: 10%;
                        animation-delay: -1s;
                        border-top-color: #ffa07a;
                    }
                }
            }

            .loading-text {
                margin: 0;
                color: #ec4b1d;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 0.5px;
                animation: pulse 1.5s ease-in-out infinite;
            }
        }
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

@keyframes pulse {
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}

.tab-menu-container {
    margin: 20px 0;
    border: 1px solid #e8e8e8;
    border-radius: 8px;
    overflow: hidden;

    .tab-header {
        display: flex;
        background: #fafafa;
        border-bottom: 1px solid #e8e8e8;

        .tab-button {
            padding: 12px 24px;
            border: none;
            background: none;
            cursor: pointer;
            font-size: 14px;
            font-weight: 500;
            color: #666;
            transition: all 0.3s ease;
            position: relative;

            &.active {
                color: #ec4b1d;
                font-weight: 600;

                &::after {
                    content: '';
                    position: absolute;
                    bottom: -1px;
                    left: 0;
                    right: 0;
                    height: 2px;
                    background: #ec4b1d;
                }
            }

            &:hover:not(.active) {
                background: rgba(236, 75, 29, 0.05);
                color: #ec4b1d;
            }
        }
    }

    .tab-content {
        padding: 20px;
        background: #fff;

        .activities-section {
            h1 {
                font-size: 18px;
                color: #333;
                margin-bottom: 15px;
                padding-bottom: 10px;
                border-bottom: 1px solid #eee;
            }
        }

        .done-status-section {
            .done-status-card {
                background: #fff;
                border: 1px solid #e8e8e8;
                border-radius: 8px;
                padding: 16px;
                margin-bottom: 16px;
                box-shadow: 0 2px 8px rgba(0,0,0,0.05);
                transition: all 0.3s ease;

                &:hover {
                    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
                    transform: translateY(-2px);
                }

                .done-status-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 12px;
                    padding-bottom: 8px;
                    border-bottom: 1px solid #f0f0f0;

                    .status-info {
                        display: flex;
                        align-items: center;
                        gap: 8px;

                        .material-icons {
                            font-size: 20px;

                            &.status-won {
                                color: #52c41a;
                            }

                            &.status-lost {
                                color: #ff4d4f;
                            }

                            &.status-paused {
                                color: #faad14;
                            }
                        }

                        .status-text {
                            font-weight: 600;
                            color: #333;
                        }
                    }

                    .status-date {
                        color: #8c8c8c;
                        font-size: 13px;
                    }
                }

                .done-status-content {
                    .user-info {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-bottom: 8px;

                        .user-name {
                            font-weight: 500;
                            color: #333;
                        }
                    }

                    .status-description {
                        color: #595959;
                        font-size: 14px;
                        line-height: 1.5;
                        padding: 8px 0;
                        margin-left: 35px;
                        border-radius: 4px;
                    }
                }
            }
        }
    }
}

</style>
